import { Spin } from "antd";

const containerStyle = {
  width: "100%",
  height: "400px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: ".5rem",
};

function Loader({ title, height }) {
  const style = {
    ...containerStyle,
  };

  if (height) style.height = height;

  return (
    <div style={style}>
      <Spin />
      <span style={{ fontSize: "14px" }}>{title || "Please wait"}</span>
    </div>
  );
}

export default Loader;
